import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    currentScreen: 'issueType',
    formData: {
        order_status_details: null,
        // other form fields
    }
};

const sahaytaCentreSlice = createSlice({
    name: 'sahaytaCentre',
    initialState,
    reducers: {
        setCurrentScreen(state, { payload }) {
            state.currentScreen = payload;
        },
        setFormData(state, { payload }) {
            state.formData = { ...state.formData, ...payload };
        },
        resetForm(state) {
            state.currentScreen = 'issueType';
            state.formData = initialState.formData;
        }
    }
});

export const { setCurrentScreen, setFormData, resetForm } = sahaytaCentreSlice.actions;
export default sahaytaCentreSlice.reducer;